import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getUsers = () => httpClient.get(`${ENDPOINT_API.USERS}`);
const getUser = (id) => httpClient.get(`${ENDPOINT_API.USERS}/${id}`);
const postUser = (params) => httpClient.post(`${ENDPOINT_API.USERS}`, params);
const putUser = (id, params) => httpClient.put(`${ENDPOINT_API.USERS}/${id}`, params);

export {
	getUsers,
	getUser,
	postUser,
	putUser,
};
